const URLs = {
  ROOT: '/',
  Login: '/login',
  Auth: '/openid-connect/forgerock',
  NewPlan: 'new-plan/:year?/:quarter?/:planId?',
  HistoricalData: 'historical-data',
  KpiResults: 'kpi-results/:inputId/:year/:quarter/:planId?',
  ActionPlan: 'action-plan/:planId/:completed?',
  Salon: '/salon/:salonId',
  SalonAfterPlanSent: '/salon/:salonId/:sent',
} as const;

export default URLs;
